/* Built In Imports */
import React, { useEffect } from 'react';

/* External Imports */
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Flex,
  UnorderedList
} from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Components */
import SimpleButton from '@components/Buttons/SimpleButton';
import SectionUI from '@components/UI/Common/SectionUI';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import DateAndTime from './DateAndTime';
import JsonTableUI from './JsonTableUI';

/* Services */
/* Styles */

/**
 * Renders the Upcoming Program Components
 *
 * @param {object} sectionContent - data for the section from api
 * @param {string} region - Region of the section
 * @param {string} lang - Language for the section
 * @returns {ReactElement} - Upcoming Program Component
 */

const UpcomingProgram = ({ sectionContent, region, lang }) => {
  useEffect(
    () => () => {
      sectionContent = [];
    },
    [sectionContent]
  );

  return (
    <Box
      w="full"
      pt="60px"
      px={{ md: 'calc((100% - 496px) / 2)', sm: '18px', base: '18px' }}
    >
      <Flex alignItems={'center'} justifyContent="center" flexDir={'row'}>
        <Box
          width="100%"
          textAlign="center"
        >
          <Box
            as="h2"
            width="100%"
            fontFamily="'FedraSansStd-A-medium', sans-serif"
            fontSize="32px"
            lineHeight="1.13"
            textAlign="center"
            color="#28231E"
          >
            {sectionContent.title.map(section => {
              return (
                <SectionUI
                  key={nanoid(5)}
                  sectionContent={section}
                  region={region}
                  language={lang}
                />
              );
            })}
          </Box>
        </Box>
      </Flex>
      <Box
        w="100%"
        height={'100%'}
        background="#ffffff"
        border="1px solid #EAEAEA"
        padding="24px"
        mt="30px"
      >
        {sectionContent.basicDetails.map(section => {
          if (section._modelApiKey === 'json_table_ui') {
            return (
              <JsonTableUI
                key={nanoid(5)}
                sectionContent={section}
                region={region}
                lang={lang}
              />
            );
          } else {
            return (
              <SectionUI
                key={nanoid(5)}
                sectionContent={section}
                region={region}
                language={lang}
              />
            );
          }
        })}
        
        <Accordion
          allowMultiple
          colorScheme={'#F0F0F0'}
          bg="#F0F0F0"
          border={'none !important'}
        >
          <AccordionItem border={'none'}>
            <h2>
              <AccordionButton>
                <Box
                  flex="1"
                  textAlign="left"
                  fontFamily="'FedraSansStd-medium', sans-serif"
                  fontSize="16px"
                  color="#28231E"
                  fontWeight={'400'}
                >
                  {sectionContent.accordianTitle}
                </Box>
                <AccordionIcon />
              </AccordionButton>
            </h2>
            <AccordionPanel pb={4}>
              <UnorderedList className="UpcomingProgram">
                <style>
                  {`
                        .UpcomingProgram li{
                          font-family:"FedraSansStd-book", sans-serif;
                    font-size:14px;
                    color:#000000;
                    padding-bottom:20px;
                    font-weight:400;
                    list-style-type:disc;
                        }                     
                      `}
                </style>

                <StructuredTextParser
                  str={render(sectionContent.accordianContent)}
                  region={region}
                  lang={lang}
                />
              </UnorderedList>
            </AccordionPanel>
          </AccordionItem>
        </Accordion>
      </Box>
      {/* Table of the component  */}
      {sectionContent &&
      sectionContent.dateAndTimeJson &&
      sectionContent.dateAndTimeJson.length ? (
        <DateAndTime
          sectionContent={sectionContent.dateAndTimeJson[0]}
          region={region}
          lang
        />
      ) : null}

      {sectionContent && sectionContent.programIncidenceDescription ? (
        <Box
          display="grid"
          placeContent="center"
          fontStyle="italic"
          color="#7E7E7E"
        >
          <StructuredTextParser
            str={render(sectionContent.programIncidenceDescription)}
            region={region}
            lang={lang}
          />
        </Box>
      ) : null}

      <Flex justifyContent={'center'} alignItems="center">
        {sectionContent.cta.map(section => {
          if (section._modelApiKey === 'simple_button') {
            return (
              <SimpleButton
                key={nanoid(5)}
                style={section}
                region={region}
                lang={lang}
              />
            );
          }
          return (
            <SectionUI
              key={nanoid(5)}
              sectionContent={section}
              region={region}
              language={lang}
            />
          );
        })}
      </Flex>
    </Box>
  );
};

export default UpcomingProgram;
